import DAOWishlist from "../../public/js/DAO/Wishlist";
import Logger from "@/assets/Helper/Logger";
import SetData from "@/vuex/SetData";
import Notification from "@/assets/Helper/Notification";
import i18n from "@/i18n";

class Wishlist {

    isRestoredFromWishlist = false;

    toggleWishlist(wishlistData) {
        return new Promise((resolve) => {
            DAOWishlist.getItemId('wishlist', wishlistData).then(wishlistItemId => {
                if (wishlistItemId === false) {
                    DAOWishlist.add('wishlist', SetData.getters.getWishlistItemData).then(() => {
                        resolve(true);
                    });

                    Notification.create(i18n.t('Wishlist.notifications.add'));
                } else {
                    DAOWishlist.drop('wishlist', wishlistItemId);
                    Notification.create(i18n.t('Wishlist.notifications.remove'));
                    resolve(false);
                }
            });
        });
    }

    toggleDiamond(id) {
        return new Promise((resolve) => {
            DAOWishlist.getDiamond(id).then(wishlistDiamondId => {
                if (wishlistDiamondId === false) {
                    DAOWishlist.add('diamonds', {
                        'date': Date.now(),
                        'id': id
                    }).then(() => {
                        resolve(true);
                    });
                } else {
                    DAOWishlist.drop('diamonds', wishlistDiamondId);
                    resolve(false);
                }
            });
        });
    }

    restoreDataFromWishlist(items) {
        return new Promise((resolve) => {
            let wishlistData = {
                items: []
            };

            for (let i in items) {
                if (Object.prototype.hasOwnProperty.call(items, i)) {

                    let itemSize = 0;
                    let itemnumber = items[i];
                    if (items[i].indexOf(":") !== -1) {
                        itemSize = parseFloat(items[i].substring(items[i].indexOf(':') + 1, items[i].length));
                        itemnumber = items[i].substring(0, items[i].indexOf(':'));
                    }

                    wishlistData.items.push({
                        itemnumber: itemnumber,
                        size: itemSize
                    })
                }
            }

            this.setIsRestoredFromWishlist(false);

            DAOWishlist.getItemId('configure', wishlistData)
                .then(wishlistItemId => {
                    if (wishlistItemId !== false) {
                        this.setIsRestoredFromWishlist(true);
                        Logger.debug("restore set data from #" + wishlistItemId);

                        DAOWishlist.getByPrimaryKey('configure', wishlistItemId).then(itemData => {
                            itemData.wishlistItemId = wishlistItemId;

                            for (let i in wishlistData.items) {
                                if (Object.prototype.hasOwnProperty.call(wishlistData.items, i) && Object.prototype.hasOwnProperty.call(itemData.items, i)) {
                                    if (wishlistData.items[i].size > 40) {
                                        itemData.items[i].size = wishlistData.items[i].size;
                                    }
                                }
                            }

                            SetData.dispatch('restoreWishlistData', itemData).then(() => {
                                if (SetData.getters.getSetId != "" && itemData.items.length > 1) {
                                    SetData.dispatch('setShowSetImage', true).catch((error) => {
                                        Logger.error(error);
                                    });
                                }
                            }).catch((error) => {
                                Logger.error(error);
                            });
                        });
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
                .catch((error) => {
                    Logger.error(error);
                });
        });
    }

    setIsRestoredFromWishlist(status) {
        this.isRestoredFromWishlist = status === true;
    }
}

export default new Wishlist();